import SearchResultsHeader from "@/components/SearchResultsHeader/SearchResultsHeader.vue";
import Footer from "@/components/Footer/Footer.vue";
import { adSubdomain, isSmallDevice } from "@/common/functions";
import Advertising from "@/components/Advertising/Advertising.vue";

export default {
    name: "LayoutStatic",
    components: {
        Advertising,
        SearchResultsHeader,
        Footer
    },
    data() {
        return {
            mobileNavIsOpen: false,
            subdomain: adSubdomain(this.$route.meta.subdomain)
        };
    },
    methods: {
        mobileMenuToggle(value) {
            this.mobileNavIsOpen = value;
        },
        isSmallDevice
    }
};



// WEBPACK FOOTER //
// ./src/layouts/LayoutStatic/LayoutStatic.js